__turbopack_context__.v({
  "break": "text-reveal-module-scss-module__ZfRqvW__break",
  "container": "text-reveal-module-scss-module__ZfRqvW__container",
  "contentWrapper": "text-reveal-module-scss-module__ZfRqvW__contentWrapper",
  "textContainer": "text-reveal-module-scss-module__ZfRqvW__textContainer",
  "word": "text-reveal-module-scss-module__ZfRqvW__word",
  "wordPlaceholder": "text-reveal-module-scss-module__ZfRqvW__wordPlaceholder",
  "wordText": "text-reveal-module-scss-module__ZfRqvW__wordText",
});
